import { render, staticRenderFns } from "./Univisionarios.vue?vue&type=template&id=14d7ff59&"
import script from "./Univisionarios.vue?vue&type=script&lang=js&"
export * from "./Univisionarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports